/*
 * 编辑器内支持的文本字体列表
 * 2022-06-12
*/
export const FONT_FAMILY_LIST = [
    {
        id: 2,
        label: '创客贴立夏体',
        value: 'ChuangKeTieLiXiaTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/d0dcbc6b2cd249c3a264a9a966479ce7.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/5fb1e10182b5539cc54973ea99d9d9e7.png'
    },
    {
        id: 3,
        label: '创客贴时黑',
        value: 'ChuangKeTieShiHei',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/5ce61e3eead681e7a5e6decca73d6395.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/6ff8677a2d143d17815863d0c1badaa6.png'
    },
    {
        id: 5,
        label: '创客贴夏至体',
        value: 'ChuangKeTieXiaZhiTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/ba5fef96868f14731d66f17c6a90d7df.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/cd7d3c3ee348dad39fba8ccd806ce80f.png'
    },
    {
        id: 6,
        label: '三级行楷简体',
        value: 'SanJiXingKaiJianTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/40cab563b796a36d336d5f5e3a1456fb.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/246e0a547d90c6f9010c1a8258e4e3c5.png'
    },
    {
        id: 7,
        label: '方圆体',
        value: 'FangYuanTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/97a251f80a4e0bde231ab9083d7e54aa.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/2e3d32319c00194701e69102634871a5.png'
    },
    {
        id: 19,
        label: '喜脉体',
        value: 'XiMaiTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/40f0320a416f9ee61563d385260de8b8.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/b7cb5b8ddb25728ed5e61a9811db782e.png'
    },
    {
        id: 20,
        label: '厚黑体',
        value: 'HouHeiTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/2f1fa0a7616633b1c5a2907a468e3da3.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/c9197d18baa1fffe40474f44feea6ac9.png'
    },
    {
        id: 23,
        label: '思源黑体',
        value: 'SiYuanHeiTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/6857d3f43b7e58b004860150eb5b69ba.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/41acfdee86a9084d5e0af1d6285f6381.png'
    },
    {
        id: 26,
        label: '思源宋体',
        value: 'SiYuanSongTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/7df546911d36dbcfd40e784acb5f2894.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/6e9526e3a002851bfa4aaa2e490920f3.png'
    },
    {
        id: 33,
        label: '仓耳渔阳体',
        value: 'CangErYuYangTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/23e416e8fe57f894eccb367cc0492ce0.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/bce7afb4a3c627f2f357b224d66d55c5.png'
    },
    {
        id: 34,
        label: '欣意吉祥宋',
        value: 'ZiTiQuanXinYiJiXiangSong',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/b775326907f70f42915dd3ef9a5b3827.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/7580c01f4ec397d9c6954a7d8df35afb.png'
    },
    {
        id: 37,
        label: '江西拙楷',
        value: 'JiangXiZhuoKai',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/b64bf35cd3b27aa3744ee03d27b3687c.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/bd7c4124ef371a4a45c62244e84b2bbc.png'
    },
    {
        id: 46,
        label: '竹石体',
        value: 'ZhuShiTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/bd2846534601e11e13e08a665c914357.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/24f9ad4a8c39381b42a725e0c2939665.png'
    },
    {
        id: 48,
        label: '欣意冠黑体',
        value: 'XinYiGuanHeiTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/6e816268d73bf891cb1e4ad5197e983a.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/b7f7d83cf22fea92e5ce17e875c3389e.png'
    },
    {
        id: 49,
        label: '传奇南安体',
        value: 'ChuanQiNanAnTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/19d43da14eb741d5b3da1543b86dc559.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/61c348b2039438312c080196510baf26.png'
    },
    {
        id: 50,
        label: '荆南波波黑',
        value: 'JinNanBoBoHei',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/842853a55055353c601304bb4cfafba5.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/56d8b1101e7a93bcf41c36f07f2a36ea.png'
    },
    {
        id: 63,
        label: '得意黑',
        value: 'DeYiHei',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/731154f63ec155bffd4b2e0cf97f055a.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/db13bab55e48fee5b46b690990714d8d.png'
    },
    {
        id: 66,
        label: '云峰飞云体',
        value: 'YunFengFeiYunTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/d180a7de2261b3d1092ebfa890e20fc1.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/9848c5214fa18ab5be19ed1c8864961b.png'
    },
    {
        id: 72,
        label: '蒙黑体',
        value: 'MengHeiTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/9c2f90f558269301f589a274fdc6fb6c.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/27c7aa8173aa849e56a144790f3a7050.png'
    },
    {
        id: 73,
        label: '男神体',
        value: 'NanShenTi',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/b79bd4e33c9288d199acba1453acfa5e.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/69913fd310334089cd40135f07cbb726.png'
    },
    {
        id: 81,
        label: 'Anton',
        value: 'Anton',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/feec91df1f4f4bbc22d119ddcaccc82b.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/801f15affda41b4e5a6f5bb4f7fdff3d.png'
    },
    {
        id: 86,
        label: 'Righteous',
        value: 'Righteous',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/b1a08d894992b0ac77d7e55fd6ffb319.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/f6232e3aa2a3ac4e7d55ee9f63d1504e.png'
    },
    {
        id: 88,
        label: 'Joan',
        value: 'Joan',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/db2192ddd9447d787159abefe85a7ae4.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/9d098cdad7cfa35541d7e5ec4827c0b0.png'
    },
    {
        id: 90,
        label: 'Rampart',
        value: 'Rampart',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/3920e157e9ed1b455a71fd7455c9f1dc.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/5c67608de92955b943667de14b332097.png'
    },
    {
        id: 91,
        label: 'Permanent',
        value: 'Permanent',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/8378c15102652da55524403b3270f9d6.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/d071d85d830632c592d311a96f5c8a73.png'
    },
    {
        id: 92,
        label: 'Teko',
        value: 'Teko',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/41dd1b0d65f9232ab4b5b1647cd8ec7e.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/e182b91eaee5bfdaee75e0c68c4d4ebc.png'
    },
    {
        id: 93,
        label: 'Lobster',
        value: 'Lobster',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/2103a683296ba487f0ba75dac7229f6a.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/2b2a00a98ea09b75435236d06269df00.png'
    },
    {
        id: 102,
        label: 'Gentium',
        value: 'Gentium',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/84cf2bbb7726a51697a0620bb4c3df8c.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/4a5bc13efbd62bee33fda37aea4f2627.png'
    },
    {
        id: 106,
        label: 'KdamThmor',
        value: 'KdamThmor',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/2b4a0c034b12511394a319091a4367da.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/8c7fd32030729c4c1e04ec44868945b9.png'
    },
    {
        id: 107,
        label: 'baidunumber',
        value: 'baidunumber-Medium',
        imageUrl: 'https://huibo-data.cdn.bcebos.com/upload/a023f26dfc429d17703634f28bd15703.png',
        selectedImageUrl: 'https://huibo-data.cdn.bcebos.com/upload/2ee283f2cdbeffb8df4cc1e07e4baf45.png'
    }
];

export const FONT_SIZE_LIST = [
    {
        label: '8',
        value: 8
    },
    {
        label: '10',
        value: 10
    },
    {
        label: '12',
        value: 12
    },
    {
        label: '13',
        value: 13
    },
    {
        label: '14',
        value: 14
    },
    {
        label: '15',
        value: 15
    },
    {
        label: '16',
        value: 16
    },
    {
        label: '17',
        value: 17
    },
    {
        label: '18',
        value: 18
    },
    {
        label: '19',
        value: 19
    },
    {
        label: '20',
        value: 20
    },
    {
        label: '21',
        value: 21
    },
    {
        label: '22',
        value: 22
    },
    {
        label: '23',
        value: 23
    },
    {
        label: '24',
        value: 24
    },
    {
        label: '25',
        value: 25
    },
    {
        label: '26',
        value: 26
    },
    {
        label: '27',
        value: 27
    },
    {
        label: '28',
        value: 28
    },
    {
        label: '29',
        value: 29
    },
    {
        label: '30',
        value: 30
    },
    {
        label: '31',
        value: 31
    },
    {
        label: '32',
        value: 32
    },
    {
        label: '33',
        value: 33
    },
    {
        label: '34',
        value: 34
    },
    {
        label: '35',
        value: 35
    },
    {
        label: '36',
        value: 36
    },
    {
        label: '37',
        value: 37
    },
    {
        label: '38',
        value: 38
    },
    {
        label: '39',
        value: 39
    },
    {
        label: '40',
        value: 40
    },
    {
        label: '41',
        value: 41
    },
    {
        label: '42',
        value: 42
    },
    {
        label: '43',
        value: 43
    },
    {
        label: '44',
        value: 44
    },
    {
        label: '45',
        value: 45
    },
    {
        label: '46',
        value: 46
    },
    {
        label: '47',
        value: 47
    },
    {
        label: '48',
        value: 48
    },
    {
        label: '49',
        value: 49
    },
    {
        label: '50',
        value: 50
    },
    {
        label: '51',
        value: 51
    },
    {
        label: '52',
        value: 52
    },
    {
        label: '53',
        value: 53
    },
    {
        label: '54',
        value: 54
    },
    {
        label: '55',
        value: 55
    },
    {
        label: '56',
        value: 56
    },
    {
        label: '57',
        value: 57
    },
    {
        label: '58',
        value: 58
    },
    {
        label: '59',
        value: 59
    },
    {
        label: '60',
        value: 60
    }
];

export const FONT_BOLD_LIST = [
    {
        label: '常规体',
        value: 'normal'
    },
    {
        label: '粗体',
        value: 'bold'
    }
];
